import { MutationTree } from 'vuex'
import { IPriceDetails } from '@/@types'

const mutations: MutationTree<IPriceDetails> = {
  CURRENCY_SYMBOL_UPDATED: (state, currencySymbol: string) => {
    state.currencySymbol = currencySymbol
  },
  CURRENCY_CODE_UPDATED: (state, currencyCode: string) => {
    state.currencyCode = currencyCode
  },
  DISCOUNT_UPDATED: (state, discount: number) => {
    state.discount = discount
    state.discountStr = discount.toFixed(2)
  },
  TOTAL_UPDATED: (state, total: number) => {
    state.total = total
    state.totalStr = total.toFixed(2)
  },
  SUBTOTAL_UPDATED: (state, subtotal: number) => {
    state.subtotal = subtotal
    state.subtotalStr = subtotal.toFixed(2)
  },
  TAXES_UPDATED: (state, taxes: number) => {
    state.taxes = taxes
    state.taxesStr = taxes.toFixed(2)
  },
  SHOW_PROMOTION_SAVINGS_UPDATED: (state, showPromotionSavings: boolean) => {
    state.showPromotionSavings = showPromotionSavings
  },
}

export default mutations
